import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { customScroll } from "./helpers";

export default function AutoScroll() {
  const { pathname } = useLocation();

  useEffect(() => {
    customScroll()
  }, [pathname]);

  return null;
}
